
export default {
	name: 'PZCategory2',
	props: {
		value: {
			type: [String, Number, null],
			require: true
		},
		list: {
			type: Array,
			required: true
		},
		keyMap: {
			type: Object,
			default: () => ({
				label: 'name',
				value: 'id'
			})
		}
	},
	data() {
		return {}
	}
}
